import { ethers } from 'ethers';
import { getNetworkProvider } from '../../lib/eth';
export const isENSAddress = (address) => {
    return address.includes('.eth');
};
export const resolveENSname = async (name, chainId) => {
    const connectedProvider = await getNetworkProvider(chainId);
    const ethersProvider = new ethers.providers.Web3Provider(connectedProvider);
    return await ethersProvider.resolveName(name);
};
//# sourceMappingURL=utils.js.map